import styled from 'styled-components';
import { white } from '../../../abstracts/colours';

interface Props {
  sticky?: boolean;
}

export const StyledHeader = styled.nav`
  min-height: 64px;
  width: 100%;
  position: ${(props: Props) => (props ? 'sticky' : 'static')};
  top: 0;
  background: ${white};
`;
